import * as React from "react";
import { Button as FluentButton } from "@fluentui/react-components";
import type { TemplateTabViewStyles } from "./TemplateTabViewStyles";

type TemplateTopStatusBannersProps = {
  isLoadingConfiguration: boolean;
  workbookDetected: boolean;
  operationError: string;
  isWorkbookBannerDismissed: boolean;
  setIsWorkbookBannerDismissed: (value: boolean) => void;
  isGenerating: boolean;
  isSaving: boolean;
  handleClearAll: () => void;
};

export const TemplateTopStatusBanners: React.FC<TemplateTopStatusBannersProps> = ({
  isLoadingConfiguration,
  workbookDetected,
  operationError,
  isWorkbookBannerDismissed,
  setIsWorkbookBannerDismissed,
  isGenerating,
  isSaving,
  handleClearAll,
}) => (
  <>
    {isLoadingConfiguration && (
      <div style={{
        marginTop: "10px",
        marginBottom: "10px",
        padding: "8px 12px",
        backgroundColor: "#EAF4FB",
        border: "0.25pt solid #42A5F5",
        borderRadius: "6px",
        color: "#0D47A1",
        fontSize: "11px",
      }}>
        Loading configuration...
      </div>
    )}

    {workbookDetected && !operationError && !isWorkbookBannerDismissed && (
      <div style={{
        marginTop: "10px",
        marginBottom: "10px",
        padding: "8px 12px",
        backgroundColor: "#EAF4FB",
        border: "0.25pt solid #42A5F5",
        borderRadius: "6px",
        color: "#0D47A1",
        fontSize: "11px",
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "10px",
        paddingRight: "34px",
      }}>
        <FluentButton
          appearance="subtle"
          size="small"
          onClick={() => setIsWorkbookBannerDismissed(true)}
          title="Hide"
          style={{
            position: "absolute",
            top: "2px",
            right: "2px",
            minWidth: "20px",
            height: "20px",
            padding: 0,
            lineHeight: 1,
          }}
        >
          &times;
        </FluentButton>
        <span>&#9432; Configuration detected from the current workbook and pre-populated.</span>
        <FluentButton
          appearance="secondary"
          size="small"
          onClick={handleClearAll}
          disabled={isGenerating || isSaving}
        >
          Clear All
        </FluentButton>
      </div>
    )}
  </>
);

type TemplateFeedbackBannersProps = {
  styles: TemplateTabViewStyles;
  operationError: string;
  operationNotice: string;
  hasGeneratedWorkbook: boolean;
};

export const TemplateFeedbackBanners: React.FC<TemplateFeedbackBannersProps> = ({
  styles,
  operationError,
  operationNotice,
  hasGeneratedWorkbook,
}) => (
  <>
    {operationError && (
      <div style={{
        marginTop: "10px",
        padding: "8px 12px",
        backgroundColor: "#FEECEC",
        border: "0.25pt solid #E53935",
        borderRadius: "6px",
        color: "#B71C1C",
        fontSize: "11px",
      }}>
        &#10007; {operationError}
      </div>
    )}

    {operationNotice && !operationError && (
      <div style={{
        marginTop: "10px",
        padding: "8px 12px",
        backgroundColor: "#FFF8E1",
        border: "0.25pt solid #FFB300",
        borderRadius: "6px",
        color: "#8A6100",
        fontSize: "11px",
      }}>
        {operationNotice}
      </div>
    )}

    {hasGeneratedWorkbook && (
      <div className={styles.successBanner}>
        &#10003; Workbook template structure generated successfully. You can now save the template.
      </div>
    )}
  </>
);
